import { LogCollection } from "../../types/logCollection";
import Api from "../api";

export default async function apiGetLogCollection(id: string) {
  return await Api.get<LogCollection>({
    input: `/api/v1/log-collection/${id}`,
  });
}
